import Header from "./Components/Header";
import Weather from "./Components/Weather";
import WeatherInfo from "./Components/WeatherInfo";

function App() {
  return (
    <div>
      <Header />
      <Weather />
      <WeatherInfo />
    </div>
  );
}

export default App;
